import { EntityIconType, EntityToneMap } from '@common/Entity/constants';
import { Entity } from '@common/types/Entity';
import { theme, BaseColor } from '@prophecy/theme';
import { Ellipsis, overlayStyle, Stack, Text, Tooltip } from '@prophecy/ui-v3';
import React from 'react';

import { useImportState } from '../../useImportState';
import { StyledBadges, StyledEntityheading } from '../styled';
import { getBaseEntityIcon } from '../utils';

export const scrollEntityItemIntoView = (key: string) => {
  const container = document?.querySelector(`[data-entityname="${key}"]`);
  if (container) {
    container.scrollIntoView({ behavior: 'smooth' });
  }
};
let scrollTimer: NodeJS.Timeout;
export const AssociatedEntity = ({
  entity,
  path,
  parentEntity
}: {
  parentEntity?: EntityIconType;
  entity: EntityIconType;
  path: string;
}) => {
  const {
    transpileGraphState: {
      clientState: {
        savedEntities: { associatedEntities }
      }
    }
  } = useImportState();
  const { icon, color } = getBaseEntityIcon(entity, 'm');
  const isJobOrDataset = entity === Entity.Job || entity === Entity.Dataset;
  const isParentDataset = parentEntity === Entity.Dataset;
  let associatedEntityData = (isJobOrDataset ? associatedEntities.pipelines : associatedEntities.jobs) as unknown as {
    [key: string]: { [key: string]: string[] };
  };

  if (isParentDataset) {
    associatedEntityData = associatedEntities.datasets as unknown as {
      [key: string]: { [key: string]: string[] };
    };
  }
  const subEntityKey = `associated${entity}s`;
  const referenceObj = associatedEntityData?.[subEntityKey];
  const referencedEntityArray = referenceObj?.[path] || [];
  const entityCount = referencedEntityArray.length;
  if (entityCount === 0) {
    return null;
  }

  const onScroll = (e: React.MouseEvent, reference: string) => {
    e.preventDefault();
    clearTimeout(scrollTimer);
    //Adding 50ms delay as frequent scroll is there on each dropdown item click
    scrollTimer = setTimeout(() => scrollEntityItemIntoView(`${entity}_${reference}`), 50);
  };

  const maxItems = 7;

  return (
    <Stack gap={theme.spaces.x10} padding={`0 0 ${theme.spaces.x12}`}>
      {parentEntity && <Text level='sm13'>Entities associated to this {parentEntity.toLowerCase()}</Text>}
      <div>
        {referencedEntityArray.slice(0, maxItems).map((reference, i) => (
          <StyledBadges
            key={reference + i}
            onClick={(e: React.MouseEvent) => onScroll(e, reference)}
            tone={EntityToneMap[entity]}
            variant='pillLight'
            icon={icon}
            iconPlacement='left'
            data-test-id={`associated-entity-${entity}-${reference}-badge`}>
            <StyledEntityheading level='sm' tone={color}>
              <Ellipsis tooltip={true} tooltipProps={{ overlayStyle }}>
                {reference}
              </Ellipsis>
            </StyledEntityheading>
          </StyledBadges>
        ))}
        {referencedEntityArray.length > maxItems ? (
          <StyledBadges key={maxItems} tone={BaseColor.gray} variant='pillLight' style={{ cursor: 'pointer' }}>
            <Tooltip
              title={
                <div>
                  {referencedEntityArray.slice(maxItems).map((entity) => (
                    <div key={entity}>{entity}</div>
                  ))}
                </div>
              }>
              <StyledEntityheading level='sm'>+{referencedEntityArray.length - maxItems}</StyledEntityheading>
            </Tooltip>
          </StyledBadges>
        ) : null}
      </div>
    </Stack>
  );
};
